<template>
  <database-management
    :headings="headings"
    :entries="entries"
    :loading="loading"
    :sort="sort"
    :sort-dir="sortDir"
    @showModal="(id) => {
      selectedEntryId = id
      showModal()
    }"
    @updateSort="(key) => {
      updateSort(key)
    }">
    <template v-slot:heading>Contract Management</template>
    <template v-slot:list>
      <contract-management-list-item
        v-for="contract in sortedEntries"
        :key="contract.id"
        :contract="contract"
        @edit="(id) => {
            selectedEntryId = id
            showModal()
          }"/>
    </template>
    <template v-slot:modal>
      <contract-management-modal
        ref="modal"
        :contract="selectedEntryIndex !== -1 ? entries[selectedEntryIndex] : defaultEntry"
        :requirements="requirements"
        @create="(contract) => { add(contract) }"
        @update="(contract) => { update(contract) }"
      />
    </template>
  </database-management>
</template>

<script>
import { http } from 'utils'
import ContractManagementListItem from './ContractManagementListItem'
import ContractManagementModal from './ContractManagementModal'
import DatabaseManagement from './templates/DatabaseManagement'
import { databaseManagement } from 'mixins'

export default {
  mixins: [databaseManagement],
  components: {DatabaseManagement, ContractManagementModal, ContractManagementListItem},
  data () {
    return {
      requirements: [],
      defaultEntryData: {
        name: null,
        description: null,
        reset_date: null,
        requirement_value: 0,
        requirement_name: null,
        admins: []
      },
      headings: [
        { key: 'id', label: 'Contract ID' },
        { key: 'name', label: 'Name' },
        { key: 'description', label: 'Description' },
        { key: 'reset_date', label: 'Reset date' },
        { key: 'start_date', label: 'Start date' },
        { key: 'end_date', label: 'End date' },
        { key: 'requirement_value', label: 'Requirement Value' },
        { key: 'requirement_name', label: 'Requirement Type' },
        { key: 'admins', label: 'Admins' }
      ]
    }
  },

  methods: {
    getContracts () {
      this.loading = true
      return http.get('contracts')
        .then((response) => {
          this.entries = response.data
          this.loading = false
        })
    }
  },

  created () {
    this.getContracts()
    http.get('contract_requirements')
      .then((response) => {
        this.requirements = response.data
      })
  }
}
</script>
